import {ValueObject} from '@s-ui/domain'

export class BlockedUsersCookiesValueObject extends ValueObject {
  #blockedUsers

  constructor({blockedUsers}) {
    super()
    this.#blockedUsers = blockedUsers || []
  }

  static createFromCookie({blockedUsersParsedCookie}) {
    return new BlockedUsersCookiesValueObject({
      blockedUsers: blockedUsersParsedCookie || []
    })
  }

  get blockedUsers() {
    return this.#blockedUsers
  }

  /**
   * Check if a specific user is blocked
   * @param {string} userId - User ID to check
   * @return {boolean} True if user is blocked
   */
  isUserBlocked(userId) {
    return Array.isArray(this.#blockedUsers) && this.#blockedUsers.includes(userId)
  }

  toJSON() {
    return {
      blockedUsers: this.#blockedUsers
    }
  }
}
